import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df50323a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df50323a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df50323a')) {
      api.createRecord('df50323a', component.options)
    } else {
      api.reload('df50323a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df50323a&scoped=true&", function () {
      api.rerender('df50323a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/order/orderOutStock/index.vue"
export default component.exports